import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { currentAccount } from "src/app/model/user/user";
import { Account } from "src/app/auth/auth.model";

@Injectable()
export class AdminSettingsService {

    getAccountMock(): Observable<Account> {
        return of(currentAccount);
    }
}